const state = {
  snackbarData: {
    open: false,
    text: "",
    color: null,
    timeout: 2000,
    top: true,
  },
};

const mutations = {
    openSnackbar:(state,snackbarData)=>{
        Object.entries(snackbarData).forEach(([key,val])=>{
            state.snackbarData[key] = val
        })
        // state.snackbarData = {
        //     ...state.snackbarData,
        //     ...snackbarData
        // }
    },
    toggleSnackbar:(state,openOrClosed)=>{
        state.snackbarData.open = openOrClosed
    }
}

export default {
    state,
    mutations
}